// extracted by mini-css-extract-plugin
export default {"breadcrumb_wrapper":"breadcrumbs_breadcrumb_wrapper__Iz102","breadcrumb":"breadcrumbs_breadcrumb__Si3mg","link":"breadcrumbs_link__xVr1J"};